<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Parcours Spirituels" />
            <ParcoursSpirituels />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ParcoursSpirituels from './ParcoursSpirituels.vue';


export default {
    name: 'MouvementPage',
    components: {
        NavBar,
        PageTitle,
        ParcoursSpirituels,
        FooterComp,
    }
}
</script>